import { render, staticRenderFns } from "./procontent.vue?vue&type=template&id=ca9e083a&scoped=true&"
import script from "./procontent.vue?vue&type=script&lang=js&"
export * from "./procontent.vue?vue&type=script&lang=js&"
import style0 from "./procontent.vue?vue&type=style&index=0&id=ca9e083a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9e083a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDialog,VIcon})
